import { FunctionComponent } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';
import { Temporal } from 'temporal-polyfill';
import { dayFormatOptions, shortMonthFormatOptions } from '../../services/dateFormats';
import { TimezoneDate } from '../TimezoneDate';

type DateIconProps = {
    date: Temporal.ZonedDateTime | string;
    className?: string;
};

export const DateIcon: FunctionComponent<DateIconProps> = ({ date, className }) => {
    return (
        <div className={classNames(styles.dateIcon, className)}>
            <span>
                <TimezoneDate date={date} format={shortMonthFormatOptions} />
            </span>
            <span>
                <TimezoneDate date={date} format={dayFormatOptions} />
            </span>
        </div>
    );
};
